import styled from 'styled-components'
import React, { useState, useEffect } from 'react'
import {dackieColors} from "utils/dackieConfigs";

const TextCarousel = ({ slides }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlideIndex((prevIndex) => (prevIndex + 1) % slides.length)
    }, 4000)

    return () => clearInterval(interval)
  }, [slides.length])

  return (
    <div className="slider">
      {slides.map((slide, index) => (
        <div key={slide.id} className={`slide ${index === currentSlideIndex ? 'active' : ''}`}>
          <h1>{slide.imageSrc}</h1>
        </div>
      ))}
    </div>
  )
}

const SpanTitle = styled.span`
  color: ${dackieColors.primary};
  font-size: 3.2rem;
  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 4.5rem;
  }
  font-weight: 600;
`

const TextAnimation = () => {
  return (
    <NimationTextWrapper>
      <SpanTitle>Dackie</SpanTitle>
      <TextCarousel slides={slides} />
    </NimationTextWrapper>
  )
}

export default TextAnimation

const NimationTextWrapper = styled.div`
  display: flex;
  align-items: center;
  .slider {
    height: 85px; /* Adjust the height as needed */
    overflow: hidden;
    position: relative;
    left: 2px;
    flex: 1;
  }

  .slide {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 24px; /* Adjust the font size as needed */
    opacity: 0;
  }

  .active {
    opacity: 1;
    z-index: 1;
    animation: slideUp 4s infinite;
  }
  .yellow {
    color: yellow;
  }
  .red {
    color: red;
  }
  .orange {
    color: orange;
  }
  .purple {
    color: purple;
  }

  @keyframes slideUp {
    0% {
      transform: translateY(-100%);
    }
    20% {
      transform: translateY(0%);
    }
    80% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(100%);
    }
  }
`
const slides = [
  {
    id: 1,
    imageSrc: <span>Swap</span>,
  },
  {
    id: 2,
    imageSrc: <span className="yellow">Pad</span>,
  },
  {
    id: 3,
    imageSrc: <span className="orange">Pool</span>,
  },
  {
    id: 4,
    imageSrc: <span className="purple">Farm</span>,
  },
  {
    id: 5,
    imageSrc: <span className="red">NFT</span>,
  },
]
